import { addEcardUtmParams, isJoyWebsiteUrl } from '@shared/utils/ecard/utm.ecard';
import { ensureHttpsPrefix } from '@shared/utils/urlHelpers';

// The href a link layer opens in the recipient view: emails become mailto:, bare domains get https,
// and Joy URLs get ecard UTMs. Built at render so the anchor's href is exactly what opens.
export const getLayerLinkHref = (raw: string): string => {
  const link = raw.trim();
  // Approximate email regex. A fully correct regex gets complicated. Excluding `/` and `:` keeps
  // URLs that contain an `@` (Google Maps `/@lat,lng`, `medium.com/@user`, `https://user@host`) as URLs.
  if (/^[^\s/:@]+@[^\s/:@]+$/.test(link)) return `mailto:${link}`;
  const url = ensureHttpsPrefix(link);
  return isJoyWebsiteUrl(url) ? addEcardUtmParams(url, { ecardType: 'premium' }) : url;
};
